export default {
  'hero.support': "We're with you 24/7",
  'hero.title': 'Not just as guides, but as your local besties on the ground!',
  'hero.subtitle': 'Authentic Vietnam journeys crafted with you — a local expert plans every step so you can simply show up and soak it all in.',
  'hero.exploreTours': 'Explore Tours',
  'hero.whereNext': 'Where do you want to go next?',
  'hero.alt': 'Vietnam Travel',
  'tourPackages.title': 'Tour Packages',
  'tourPackages.durationAll': 'Duration: All',
  'tourPackages.days1to3': '1-3 Days',
  'tourPackages.days4to7': '4-7 Days',
  'tourPackages.days8plus': '8+ Days',
  'tourPackages.viewAll': 'View all',
  'tourPackages.empty': 'No tours available yet. Check back soon!',
  'tourPackages.spots': '{{count}} Spots',
  'tourPackages.from': 'FROM',
  'tourPackages.view': 'View',
  'experiences.empty': 'No experiences available in this region yet.',
  'experiences.from': 'FROM {{price}} USD',
  'home.northernExperiences': 'Best Experiences in Northern Vietnam',
  'home.centralExperiences': 'Best Experiences in Central Vietnam',
  'home.southernExperiences': 'Best Experiences in Southern Vietnam',
  'search.placeholder': 'Search your dream destination...',
  'search.button': 'Search',
  'search.clear': 'Clear search',
  'search.error': "Couldn't load destinations.",
  'search.noResult': 'No destination found for "{{query}}"',
  'channel.title': 'Our channel',
  'channel.team': 'Our team',
  'channel.guide': 'Travel guide',
  'channel.internet': 'Internet vs. Local expert',
  'channel.expert': 'Choice of expert',
  'channel.essentials': 'Travel essentials',
  'reviews.howEarn': 'HOW DID WE EARN',
  'reviews.star': '4.9 STAR',
  'reviews.on': 'ON',
  'reviews.empty': 'No reviews yet.',
  'reviews.showLess': 'Show less',
  'reviews.readMore': 'Read more',
  'reviews.postedOn': 'Posted on Tripadvisor',
  'experience.breadcrumb': 'Breadcrumb',
  'experience.notFound': 'Experience not found',
  'experience.backHome': 'Back to Homepage',
  'experience.home': 'Home',
  'experience.experiences': 'Experiences',
  'experience.ctaTitle': 'Want to book this experience?',
  'experience.ctaText': 'Tell us your dates and preferences, and a local expert will get back to you with a tailored plan. Nothing is booked or charged at this stage.',
  'experience.contactExpert': 'Contact a local expert',
  'experience.priceFrom': 'Indicative price from',
  'experience.category': 'Category',
  'experience.travelStyle': 'Travel style',
  'experience.region': 'Region',
  'experience.enquire': 'Enquire now',
  'experience.regionNorthern': 'Northern Vietnam',
  'experience.regionCentral': 'Central Vietnam',
  'experience.regionSouthern': 'Southern Vietnam',
};